import { Dispatch, SetStateAction, SVGProps } from 'react';

export const INVITE_GUEST = 'INVITE_GUEST';
export const BOX_OFFICE = 'BOX_OFFICE';
export const OFFLINE_SALES = 'OFFLINE_SALES';
export const IMPORT_CSV = 'IMPORT_CSV';
export type ActionModalType = typeof INVITE_GUEST | typeof BOX_OFFICE | typeof OFFLINE_SALES | typeof IMPORT_CSV;
export type FilteredActionModalType = Exclude<ActionModalType, typeof IMPORT_CSV>;

export type ActionMenuButtonOptions = Partial<Record<ActionModalType, ActionModalButtonItem>>;

export type CombinedActionModalType = ActionModalType | FilteredActionModalType;

export type ModalTypes = ActionModalType | '';

export interface ModalContextValue {
  currentModalType: ModalTypes;
  setPreventExit: Dispatch<SetStateAction<boolean>>;
  handleCloseModal: () => void;
  toggleModal: ({ type, isOpen }: { type: ModalTypes; isOpen?: boolean }) => void;
}

export interface ActionModalButtonItem {
  name: string;
  component: () => JSX.Element;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}
